export default "__VITE_ASSET__C$zxmF29__"